import '../polyfills';
import React from 'react';
import { createRoot } from 'react-dom/client';

import './stylesheets';

import '@infotech-soe/iit-eusw/eusw.exec.js';
import '@infotech-soe/iit-eusw/euswll.exec.js';
import '@infotech-soe/iit-eusw/main.exec.js';
import { isDevEnv } from '../helpers';

import App from './App';
import { register } from './service-worker/registration';

const container = document.getElementById('root') as HTMLElement;
const root = createRoot(container);

!isDevEnv() && void register();
root.render(<App />);

if (isDevEnv() && module.hot) {
  module.hot.accept('./App', () => {
    setTimeout(() => root.render(<App />), 0);
  });
}
